
export interface LastUsed<T> {
  id: string | number;
  object: T;
  timestamp: string;
}
